import React from "react";

export const LoginLogTableHead = React.memo(function LoginLogTableHead() {
    return (
        <thead>
            <tr>
                <th>No.</th>
                <th>ユーザー名</th>
                <th>Eメール</th>
                <th>権限</th>
                <th>ログイン日時</th>
            </tr>
        </thead>
    );
});